import { useState, useEffect } from 'react';
import {
  INITIAL_PAGE_INDEX,
  ITEMS_PER_PAGE,
  VISIBLE_PAGES,
  ROWS_PER_PAGE,
} from '../../../constants';

const calculateTotalPages = (assets: any[], pageSize: number) => {
  return Math.ceil(assets.length / pageSize);
};

const getSlicedAssets = (
  assets: any[],
  pageSize: number,
  pageIndex: number
) => {
  const startIndex = pageSize * pageIndex - pageSize;
  const endIndex = pageSize * pageIndex;
  return assets.slice(startIndex, endIndex);
};

const useMobileViewPagination = (
  assets: any[],
  initialPageSize = ITEMS_PER_PAGE
) => {
  const [mobileViewPageSize, setMobileViewPageSize] = useState<number>(
    initialPageSize
  );
  const [pageIndex, setPageIndex] = useState<number>(INITIAL_PAGE_INDEX);
  const [mobileViewData, setMobileViewData] = useState<any[]>([]);
  const [totalPages, setTotalPages] = useState<number>(0);

  useEffect(() => {
    if (assets.length === 0) {
      setPageIndex(0);
    } else {
      setPageIndex(INITIAL_PAGE_INDEX);
    }
  }, [assets]);

  useEffect(() => {
    if (assets.length > 0) {
      const mobileDataAsset = getSlicedAssets(
        assets,
        mobileViewPageSize,
        pageIndex
      );
      const totalPagesAsset = calculateTotalPages(assets, mobileViewPageSize);

      setTotalPages(totalPagesAsset);
      setMobileViewData(mobileDataAsset);
    } else {
      const mobileDataAsset = getSlicedAssets(
        assets,
        mobileViewPageSize,
        pageIndex
      );
      const totalPagesAsset = calculateTotalPages(assets, mobileViewPageSize);

      setMobileViewData(mobileDataAsset);
      setTotalPages(totalPagesAsset);
    }
  }, [assets, pageIndex, mobileViewPageSize, mobileViewData.length]);

  const handlePageChange = (newPageIndex: number) => {
    setPageIndex(newPageIndex);
  };

  const handlePageSizeChange = (newPageSize: number) => {
    const totalPagesAsset = calculateTotalPages(assets, newPageSize);

    setMobileViewPageSize(newPageSize);
    setTotalPages(totalPagesAsset);
    setPageIndex(INITIAL_PAGE_INDEX);
  };
  return {
    mobileViewPageSize,
    totalPages,
    VISIBLE_PAGES,
    ROWS_PER_PAGE,
    mobileViewData,
    handlePageChange,
    handlePageSizeChange,
    totalItems: assets.length,
    pageIndex,
  };
};

export default useMobileViewPagination;
